import { useMemo } from 'react';
import { useListInsurersQuery } from '../../../../api';
import { useCompany } from '../../../../components/contexts/CompanyContextManager';

const useInsurerOption = () => {
    const company = useCompany(true);

    const { data } = useListInsurersQuery({
        fetchPolicy: 'cache-and-network',
        variables: { filter: { companyId: company?.id } },
    });

    return useMemo(() => {
        const items = data?.list?.items || [];

        return {
            items,
            options: items.map(insurer => ({
                label: insurer.displayName,
                value: insurer.id,
            })),
            moduleIdByInsurerId: Object.fromEntries(items.map(({ id, module }) => [id, module.id])),
            availableInsuranceProductTypeByInsurerId: Object.fromEntries(
                items.map(({ id, insuranceProductTypes }) => [id, insuranceProductTypes])
            ),
        };
    }, [data]);
};

export default useInsurerOption;
